module.exports = __webpack_public_path__ + "static/img/siegfried.7ef7ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/siegfried.png
// module id = 9reW
// module chunks = 0